import { render, staticRenderFns } from "./editrubrik.vue?vue&type=template&id=4b00e576&"
import script from "./editrubrik.vue?vue&type=script&lang=js&"
export * from "./editrubrik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports